import styled from "@emotion/styled";

export const StyledVerticalDivider = styled.div`
  width: 1px;
  height: 100%;
  min-height: ${({ theme }) => theme.spacing["5"]};
  margin: 0 ${({ theme }) => theme.spacing["2"]};
  background-color: ${({ theme }) => theme.colors.border.default};
`;
